export default "__VITE_ASSET__d62ff04b__"